import React from 'react';

import './CertificateInfo.css';

import HeaderInsideFooter from './HeaderInsideFooter';

import Diploma from '../../../diploma/Diploma';


const CertificateInfo = () => {

  return (

    <div className="certificate-info-page">

      <HeaderInsideFooter />


      <div className="certificate-info-layout">


        {/* =========================
            STANGA
        ========================= */}

        <div className="certificate-info-left">


          <div className="certificate-info-intro">

            <span className="certificate-info-eyebrow">
              Certificare ContaLearn
            </span>

            <h1 className="certificate-info-title">
              Demonstreaza progresul tau printr-un certificat verificabil
            </h1>

            <p className="certificate-info-description">
              La finalizarea unui curs eligibil, ContaLearn iti ofera
              un certificat digital care confirma finalizarea cursului
              si poate fi verificat online printr-un cod unic.
            </p>

          </div>


          {/* =========================
              CUM IL OBTII
          ========================= */}

          <section className="certificate-info-mini-section">

            <div className="certificate-info-mini-header">

              <span className="certificate-info-number">
                02
              </span>

              <h2>
                Cum obtin o certificare ContaLearn?
              </h2>

            </div>

            <p>
              Finalizeaza un curs eligibil pe ContaLearn.
              Dupa finalizare, certificatul este emis automat
              si devine disponibil in contul tau.
            </p>

          </section>


          {/* =========================
              DE CE ESTE UTIL
          ========================= */}

          <section className="certificate-info-mini-section">

            <div className="certificate-info-mini-header">

              <span className="certificate-info-number">
                03
              </span>

              <h2>
                De ce este util un certificat ContaLearn?
              </h2>

            </div>

            <p>
              Certificatul poate sustine prezentarea progresului tau
              educational si ofera o metoda simpla prin care o alta
              persoana poate verifica autenticitatea documentului.
            </p>

          </section>


          {/* =========================
              VERIFICARE
          ========================= */}

          <section className="certificate-info-mini-section">

            <div className="certificate-info-mini-header">

              <span className="certificate-info-number">
                04
              </span>

              <h2>
                Cum poate fi verificat?
              </h2>

            </div>

            <p>
              Fiecare certificat primeste un cod unic si un cod QR.
              Scanarea codului QR deschide pagina publica de verificare
              a certificatului.
            </p>

          </section>


          {/* =========================
              LINKEDIN
          ========================= */}

          <section className="certificate-info-mini-section">

            <div className="certificate-info-mini-header">

              <span className="certificate-info-number">
                05
              </span>

              <h2>
                Poate fi distribuit pe LinkedIn?
              </h2>

            </div>

            <p>
              Da. Certificatul poate fi descarcat in format PDF,
              iar linkul public de verificare poate fi distribuit
              pe LinkedIn sau pe alte platforme.
            </p>

          </section>


        </div>


        {/* =========================
            DREAPTA
        ========================= */}

        <div className="certificate-info-right">


          <section className="certificate-info-preview-section">

            <div className="certificate-info-section-header">

              <span className="certificate-info-number">
                01
              </span>

              <div>

                <h2>
                  Exemplu de certificat ContaLearn
                </h2>

                <p>
                  Asa poate arata certificatul primit dupa finalizarea
                  unui curs eligibil.
                </p>

              </div>

            </div>


            <div className="certificate-info-preview-wrapper">

              <Diploma
                previewUser={{
                  id: 'DEMO-2026-001',
                  username: 'Andrei Popescu'
                }}
                previewMode
              />

            </div>

          </section>


        </div>


      </div>

    </div>

  );

};


export default CertificateInfo;